<template>

  <div :class="{'table-graph':true,colours:!settings.hidden}">

	<span
        v-for="(bar, barIndex) in bars" 
        :key="barIndex" 
        :class="{ 'bar': true, ['bar'+(barIndex+1)]: true }"
		:style="'height:'+bar.percent+'%'"
		:title="barTitle(bar)"
    />

  </div>

</template>

<script>
export default {
  name: 'TableGraph',
  props: ['settings'],
  methods: {
	barTitle(bar) {
		if ( typeof bar.month !== 'undefined' ) {
			let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
			return months[bar.month] + ' ' + bar.year + ': ' + bar.amount;
		}
		return bar.amount;
	}
  },
  computed: {
	bars () {
		let bars = this.settings.bars;
		return Array.isArray( bars[0] ) ? bars[0] : bars;
	}
  }
}
</script>
<style lang="less" scoped>
.table-graph {

	height: 30px;
	position: relative;
	box-sizing: border-box;
	display: block;
	margin: 8px 0 0 13px;
	text-align: left;

	.bar {

		width: 4px;
		display: inline-block;
		margin-right: 3px;
		background-color: #84807a;

		&.bar1 {
			background-color: #f88800;
		}
		&.bar2 {
			background-color: #f98702;
		}
		&.bar3 {
			background-color: #f68302;
		}
		&.bar4 {
			background-color: #f47d07;
		}
		&.bar5 {
			background-color: #f2780b;
		}
		&.bar6 {
			background-color: #f2780b;
		}
		&.bar7 {
			background-color: #ed6e11;
		}
		&.bar8 {
			background-color: #ea6715;
		}
		&.bar9 {
			background-color: #e86318;
		}
		&.bar10 {
			background-color: #e35b1f;
		}
		&.bar11 {
			background-color: #de4f25;
		}
		&.bar12 {
			background-color: #dd4a29;
		}

	}

}
</style>